// extracted by mini-css-extract-plugin
export default {"sideCart":"styles_sideCart__Sw-9Z","sideCartShow":"styles_sideCartShow__FphLC","notAModal":"styles_notAModal__YBwmx"};